<template>
  <v-expansion-panels v-model="panel" class="mt-2" multiple focusable>
    <template v-for="content in panelData">
      <v-expansion-panel class="my-2" :key="content.label">
        <v-expansion-panel-header
          ><h6 class="mb-0">
            Message template for {{ convertToUpperCase(content.label) }}
          </h6></v-expansion-panel-header
        >
        <v-expansion-panel-content>
          <LineMessageTemplate
            v-show="form.isSentViaLine"
            :trigger-type="form.triggerType"
            :message-template="form['messageTemplatesFor' + content.label]"
            :error-message-templates="
              error['errorMessageTemplatesLineFor' + content.label]
            "
            :error="error"
            :is-submit="isSubmit"
            :data-id="
              'message-tooltip-' + convertToLowerCase(content.label) + '-line'
            "
            :identifier="convertToLowerCase(content.label) + 'Template'"
          />
          <SmsMessageTemplate
            v-show="form.isSentViaSms"
            :trigger-type="form.triggerType"
            :message-template="form['messageTemplatesFor' + content.label]"
            :error-message-templates="
              error['errorMessageTemplatesSmsFor' + content.label]
            "
            :is-submit="isSubmit"
            :data-id="'message-tooltip-' + content.label + '-sms'"
            :identifier="convertToLowerCase(content.label) + 'Template'"
          />
          <PushNotificationTemplate
            v-show="form.isSentViaPushNoti"
            :trigger-type="form.triggerType"
            :message-template="form['messageTemplatesFor' + content.label]"
            :error-message-templates="
              error['errorMessageTemplatesPushNotiFor' + content.label]
            "
            :error="error"
            :is-submit="isSubmit"
            :data-id="
              'message-tooltip-' +
              convertToLowerCase(content.label) +
              '-push-noti'
            "
            :identifier="convertToLowerCase(content.label) + 'Template'"
          />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </template>
  </v-expansion-panels>
</template>

<script>
import SmsMessageTemplate from "components/MessageTemplate/SmsMessageTemplate.vue";
import LineMessageTemplate from "components/MessageTemplate/LineMessageTemplate.vue";
import PushNotificationTemplate from "components/MessageTemplate/PushNotificationTemplate.vue";

export default {
  components: {
    LineMessageTemplate,
    SmsMessageTemplate,
    PushNotificationTemplate,
  },
  props: {
    errorMessageTemplates: {
      type: Object,
      default: () => {},
    },
    error: {
      type: Object,
      default: () => {},
    },
    form: {
      type: Object,
      default: () => {},
    },
    isSubmit: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      panel: [0, 1],
      panelData: [
        {
          label: "Hv",
        },
        {
          label: "Lv",
        },
      ],
    };
  },
  methods: {
    convertToUpperCase(text) {
      return text.toUpperCase();
    },
    convertToLowerCase(text) {
      return text.toLowerCase();
    },
  },
};
</script>
